import { useState } from 'react';
import { FaEye, FaEyeSlash } from 'react-icons/fa6';

interface PasswordFieldProps {
  id: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  autoComplete?: string;
  required?: boolean;
}

/**
 * Monospace password input with a show/hide toggle, matching the login card's
 * styling. Each instance manages its own visibility state.
 */
export function PasswordField({
  id,
  label,
  value,
  onChange,
  autoComplete = 'new-password',
  required = true,
}: PasswordFieldProps) {
  const [show, setShow] = useState(false);

  return (
    <div>
      <label htmlFor={id} className="font-mono text-sm text-muted">
        {label}
      </label>
      <div className="relative mt-1">
        <input
          id={id}
          type={show ? 'text' : 'password'}
          autoComplete={autoComplete}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          required={required}
          className="w-full rounded-md border border-border bg-bg px-3 py-2 pr-10 font-mono text-sm text-fg outline-none focus:border-accent"
        />
        <button
          type="button"
          onClick={() => setShow((v) => !v)}
          aria-label={show ? 'Hide password' : 'Show password'}
          className="absolute inset-y-0 right-0 flex w-10 items-center justify-center text-muted hover:text-accent"
        >
          {show ? <FaEyeSlash /> : <FaEye />}
        </button>
      </div>
    </div>
  );
}
